export default __webpack_public_path__ + "static/6fce2220154bf214128646cb9d8360a7.jpg";